import React, { useEffect } from 'react';
import {
    useProperty,
    usePropertyFetching,
    usePropertyValidation,
} from '../../../contextsProperty/ContextProperties';
import TextInput from '../../../../muiComponents/TextInput/TextInputV2';
import Grid from '../../../../muiComponents/Grid';
import GridChild from '../../../../muiComponents/GridChild';
import SwitchInput from '../../../../muiComponents/switchInput/SwitchInput';
import {
    doubleColumnGrid,
    fullColumnGrid,
} from '../../../../utils/property/propertyUtils';
import { PROGRESS_MAIN_INFORMATION_TAB } from '../../../../types/properties/propertyTypes';
import '../../../../stylesheets/stylesLayout/yourProperties.scss';
import LoadingTab from '../LoadingTab';
import Title from '../Title';
import Card from '../../../../muiComponents/Card';
import {
    gridSpacing30,
    gridSpacing40,
} from '../../../../utils/commonVariables/grid';

export default function Commercial() {
    const {
        primary,
        email,
        phone,
        bookingEmail,
        bookingPhone,
        accountingEmail,
        accountingPhone,
        isDifferentContactInfo,
        handleIsDifferentContactInfo,
        handleInputChange,
    } = useProperty();
    const { handleIsValidated, errors, isValidated, handleValidate } =
        usePropertyValidation();
    const { isFetching } = usePropertyFetching();

    useEffect(() => {
        return () => handleIsValidated(false);
    }, []);

    const handleBlur = () => {
        if (isValidated) {
            handleValidate(PROGRESS_MAIN_INFORMATION_TAB.CONTACT);
        }
    };
    if (isFetching) {
        return <LoadingTab />;
    }
    return (
        <div className='your-property__container'>
            <Title
                as='h1'
                text={'contact_data'}
                className='text-align-center'
            />
            <Card className='your-properties__form'>
                <Grid columnSpacing={gridSpacing30} rowSpacing={gridSpacing40}>
                    <GridChild gridProps={doubleColumnGrid}>
                        <TextInput
                            labelText='general_phone'
                            handleChange={e =>
                                handleInputChange('phone', e.target.value)
                            }
                            value={phone}
                            errorMessage={errors.phone}
                            onBlur={handleBlur}
                            name='phone'
                            type='text'
                            required
                            id='phone'
                            disabled={!primary}
                            variant={!primary ? 'filled' : 'outlined'}
                            error={!!errors.phone}
                        />
                    </GridChild>
                    <GridChild gridProps={doubleColumnGrid}>
                        <TextInput
                            labelText='general_email'
                            handleChange={e =>
                                handleInputChange('email', e.target.value)
                            }
                            value={email}
                            errorMessage={errors.email}
                            onBlur={handleBlur}
                            name='email'
                            type='email'
                            required
                            id='email'
                            disabled={!primary}
                            variant={!primary ? 'filled' : 'outlined'}
                            error={!!errors.email}
                        />
                    </GridChild>
                    <GridChild gridProps={fullColumnGrid}>
                        <SwitchInput
                            labelText={'want_to_set_diferent'}
                            checked={isDifferentContactInfo}
                            onChangeMethod={(_e, checked) =>
                                handleIsDifferentContactInfo(checked)
                            }
                        />
                    </GridChild>
                </Grid>
                {isDifferentContactInfo && (
                    <Grid
                        columnSpacing={gridSpacing30}
                        rowSpacing={gridSpacing40}
                    >
                        <GridChild gridProps={doubleColumnGrid}>
                            <TextInput
                                labelText='reservation_phone'
                                handleChange={e =>
                                    handleInputChange(
                                        'bookingPhone',
                                        e.target.value
                                    )
                                }
                                value={bookingPhone}
                                name='bookingPhone'
                                type='text'
                                id='bookingPhone'
                                disabled={!primary}
                                variant={!primary ? 'filled' : 'outlined'}
                            />
                        </GridChild>
                        <GridChild gridProps={doubleColumnGrid}>
                            <TextInput
                                labelText='reservation_email'
                                handleChange={e =>
                                    handleInputChange(
                                        'bookingEmail',
                                        e.target.value
                                    )
                                }
                                value={bookingEmail}
                                name='bookingEmail'
                                type='email'
                                id='bookingEmail'
                                disabled={!primary}
                                variant={!primary ? 'filled' : 'outlined'}
                            />
                        </GridChild>
                        <GridChild gridProps={doubleColumnGrid}>
                            <TextInput
                                labelText='accounting_phone'
                                handleChange={e =>
                                    handleInputChange(
                                        'accountingPhone',
                                        e.target.value
                                    )
                                }
                                value={accountingPhone}
                                name='accountingPhone'
                                type='text'
                                id='accountingPhone'
                                disabled={!primary}
                                variant={!primary ? 'filled' : 'outlined'}
                            />
                        </GridChild>
                        <GridChild gridProps={doubleColumnGrid}>
                            <TextInput
                                labelText='accounting_email'
                                handleChange={e =>
                                    handleInputChange(
                                        'accountingEmail',
                                        e.target.value
                                    )
                                }
                                value={accountingEmail}
                                name='accountingEmail'
                                type='text'
                                id='accountingEmail'
                                disabled={!primary}
                                variant={!primary ? 'filled' : 'outlined'}
                            />
                        </GridChild>
                    </Grid>
                )}
            </Card>
        </div>
    );
}
